export default {
  baseProgram: ["VNPJ", "VNR", "VO"],
  newProgram: ["VNPJ", "VNR"],
  vnpjProgram: ["VNPJ"],
  vnrProgram: ["VNR"],
  voProgram: ["VO"],
}
